import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-132d099a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "formCap" }, "ご渡航期間", -1))
const _hoisted_2 = { class: "block travel-term" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "travel-text" }, " 日本時間を基準に、出発日と帰国日をご選択ください。 ", -1))
const _hoisted_4 = { class: "travel-dates" }
const _hoisted_5 = { class: "departure-date" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "出発日", -1))
const _hoisted_7 = { class: "arriving-date" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "帰国日", -1))
const _hoisted_9 = { class: "calculated-term" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "term" }, "渡航期間 ：", -1))
const _hoisted_11 = { class: "days" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "日間", -1))
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"travel-term-notice\" data-v-132d099a><p class=\"travel-term-noticeCap\" data-v-132d099a> 申込可能期日がお受取方法によって異なりますので、ご注意ください。 </p><p class=\"travel-term-noticeTxt\" data-v-132d099a><span data-v-132d099a>● 宅配</span>で受取の場合 / <br class=\"sp_d\" data-v-132d099a>ご出発日<strong data-v-132d099a>2日前の15時まで(土日祝も発送)</strong></p><p class=\"travel-term-noticeTxt\" data-v-132d099a><span data-v-132d099a>● 成田空港</span>で受取の場合 / <br class=\"sp_d\" data-v-132d099a>ご出発日<strong data-v-132d099a>2日前の12時まで</strong></p><p class=\"travel-term-noticeTxt\" data-v-132d099a><span data-v-132d099a>● 羽田空港</span>で受取の場合 / <br class=\"sp_d\" data-v-132d099a>ご出発日<strong data-v-132d099a>5日前の24時まで</strong></p><p class=\"travel-term-noticeTxt\" data-v-132d099a><span data-v-132d099a>● 中部国際空港</span>で受取の場合 / <br class=\"sp_d\" data-v-132d099a>ご出発日<strong data-v-132d099a>5日前の24時まで</strong></p><p class=\"travel-term-noticeTxt\" data-v-132d099a><span data-v-132d099a>● 新千歳空港</span>で受取の場合 / <br class=\"sp_d\" data-v-132d099a>ご出発日<strong data-v-132d099a>5日前の24時まで</strong></p></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_calender_input = _resolveComponent("calender-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("dl", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("dd", null, [
            _createVNode(_component_calender_input, {
              name: "order_from_date",
              "model-value": _ctx.departureDate,
              "min-date": _ctx.minOrderDate,
              "start-date": _ctx.minOrderDate,
              "hide-offset-date": true,
              "onUpdate:modelValue": _ctx.onUpdateDepartureDate,
              rules: _ctx.validRules.departureDate
            }, null, 8, ["model-value", "min-date", "start-date", "onUpdate:modelValue", "rules"])
          ])
        ]),
        _createElementVNode("dl", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("dd", null, [
            _createVNode(_component_calender_input, {
              name: "order_to_date",
              "model-value": _ctx.arrivalDate,
              "min-date": _ctx.minArrivalDate,
              "start-date": _ctx.minOrderDate,
              "hide-offset-date": true,
              "onUpdate:modelValue": _ctx.onUpdateArrivalDate,
              rules: _ctx.validRules.arrivalDate
            }, null, 8, ["model-value", "min-date", "start-date", "onUpdate:modelValue", "rules"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.travelingDays), 1),
          _hoisted_12
        ])
      ]),
      _hoisted_13
    ])
  ], 64))
}